module.exports = __webpack_public_path__ + "media/AUDIO-07.04ec8719.mp3";